"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchEolConfig = exports.hasMonetizationStopped = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_EOL_CONFIG = "SET_EOL_CONFIG";
var SET_IS_LOADING = "SET_IS_LOADING";

var initialState = {
  isLoading: true,
  eolConfig: null,
  hasFabLaunched: false,
  hasMonetizationStopped: null
};

var hasMonetizationStopped = exports.hasMonetizationStopped = false;

var fetchEolConfig = exports.fetchEolConfig = function fetchEolConfig() {
  return function (dispatch) {
    return _axios2.default.get(_config2.default.eolConfigUrl).then(function (_ref) {
      var data = _ref.data;

      dispatch({
        type: SET_EOL_CONFIG,
        payload: data
      });
    }).catch(function (error) {
      console.error("Failed to fetch EOL config file:", error);
      dispatch({
        type: SET_IS_LOADING,
        payload: false
      });
    });
  };
};

var eol = function eol() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_EOL_CONFIG:
      var eolConfig = action.payload;
      exports.hasMonetizationStopped = hasMonetizationStopped = !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.stopMonetizingDate));
      return (0, _extends3.default)({}, state, {
        eolConfig: eolConfig,
        isLoading: false,
        hasFabLaunched: !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.fabLaunchDate)),
        hasMonetizationStopped: hasMonetizationStopped
      });

    case SET_IS_LOADING:
      return (0, _extends3.default)({}, state, {
        isLoading: action.payload
      });

    default:
      return state;
  }
};

exports.default = eol;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/eol.js
// module id = 516
// module chunks = 0